export const config = {
  myGithubLink: "https://www.github.com/https-sam",
  myLinkedinLink: "https://www.linkedin.com/in/samgoto",
};
